export default "/static/fluostar_omega_tiny.png";